import Vue from 'vue'
import Antd from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import _ from 'lodash'

import 'ant-design-vue/dist/antd.css'

import http from './libs/http'

import filters from './filters'

import enums from './libs/enum'

import InitComp from '@/comp/init'

Vue.prototype.$http = http

Vue.prototype.$enums = enums

Vue.prototype._ = _

Vue.config.productionTip = false

Vue.use(InitComp)

Vue.use(Antd)

const hasRole = function(role) {
    let user = store.state.User
    if (role === 'auth' && user !== undefined && user.id) {
        return true
    }
    if (!user || !user.role) {
        return false
    }
    if (user.role && role.toLowerCase() === user.role.toLowerCase()) {
        return true
    }
    return false
}

Vue.prototype.$has = hasRole

Vue.directive('has', {
    bind: function(el, binding) {
        let flg = false
        if (binding.value.indexOf(',') >= 0) {
            for (let role of binding.value.split(',')) {
                flg = hasRole(role)
                if (flg) break
            }
        } else {
            flg = hasRole(binding.value)
        }
        if (!flg) {
            if (el.parentNode) {
                el.parentNode.removeChild(el)
            } else {
                el.style.display = 'none'
            }
        }
    }
})

Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

new Vue({
    router,
    store,
    beforeMount() {
        let self = document.getElementById('bootSpinner')
        self.parentElement.removeChild(self)
    },
    render: h => h(App)
}).$mount('#app')
